export default {
  name: 'AppItemCreate',

  data() {
    return {
      customObject: {
        title: 'Custom Object',
        description: 'Custom objects are a JSON schema of data types which define the make up of a custom object. They have multiple data types which are required to identify and search for them. Select ‘New object’ to get started.',
        routeName: 'custom-object-edit',
        itemName: 'custom-object-1',
      },
      scriptPack: {
        title: 'Script Pack',
        description: 'Scripts work by allowing a developer to create a bundle or \'pack\' of scripts that are all uploaded as a single lambda/node function set. These can then individually respond to different types of actions. Select‘ New script pack’ to get started.',
        routeName: 'script-pack-edit',
        itemName: 'script-pack-1',
      },
      panelItem: {
        title: 'Panel',
        description: 'Panels are used in Studio to handle custom functionality. They are visible in Studio when loaded in via the configurator and viewed/used by back admins and staff. Select‘ New panel’ to get started.',
        routeName: 'panel-item-edit',
        itemName: 'panel-1',
      },
    };
  },

  props: {
    itemType: {
      type: String,
      required: true,
    },
  },

  computed: {
    title() {
      return this[this.itemType].title;
    },
    description() {
      return this[this.itemType].description;
    },
    routeName() {
      return this[this.itemType].routeName;
    },
    itemName() {
      return this[this.itemType].itemName;
    },
  },

};
